import { useState } from "react";
import AppSearchBox from "../../../components/searchBox";
import { SearchPreview } from "../type";
import { useNavigate } from "react-router-dom";
import { routeUrls } from "../../../navigation/routeUrls";

import { useFetchSearchResultsApiQuery } from "../../../api/network/helpApiServices";
import { useDebouncedSearch } from "../debouncedSearch";
import svgIcons from "../../../assets/svg/svgIcons";

const HelpMainSearch = () => {

  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  // When search keyword length is more than 3 and after 300ms, search API is called
  const debouncedSearch = useDebouncedSearch(searchQuery, 3, 300);
  const {
    data: searchResults,
    isLoading: searchLoading
  } = useFetchSearchResultsApiQuery(debouncedSearch, { skip: !debouncedSearch })

  const handleSearchResultClick = (slug: string, itemMatch: SearchPreview) => {
    if (itemMatch.matched_section === "Article Title" || itemMatch.matched_section === "Article Description") {
      navigate(routeUrls.dashboardChildren.help + `/${slug}`);
    }
    else {
      //Passing itemMatch as state to scroll to the content
      navigate(routeUrls.dashboardChildren.help + `/${slug}`, { state: { itemMatch } });
    }
  }

  const hideDropdown = () => {
    setSearchQuery("");
  }

  return (
    <div className="w-full max-w-xl mx-auto relative">
      {searchQuery.length >= 3 && (
        <div className="fixed top-0 left-0 w-full h-screen bg-white/70 backdrop-blur-[1px] z-popup-overlay" onClick={hideDropdown}></div>
      )}
      <div className={`relative ${searchQuery.length > 0 ? 'z-popup' : ''}`}>
        <AppSearchBox
          placeholder="Search for help articles, guides, and tutorials..."
          inputClassName="py-5 w-full rounded-xl border-gray-200 ps-14 shadow-sm sm:text-sm"
          searchIconClassName=" pl-3.5 w-14"
          onChange={(e) => {
            if (e.target.value.length === 0 || e.target.value.length >= 3) setSearchQuery(e.target.value);
          }}
          onClear={() => {
            setSearchQuery("");
          }}
          loading={searchLoading}
        />
        {searchQuery.length >= 3 && (
          <div className="flex flex-col justify-between absolute top-full left-0 right-0 z-popup bg-white border border-black/10 rounded-lg shadow-lg gap-1 max-h-96 overflow-y-auto max-w-full mt-3 py-2">
            {
              searchLoading ?
                (<div className={`relative z-10 w-full h-48`}>
                  <img src={svgIcons.LoadingAnimation} alt="loading-animation" className="size-16 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                </div>) :
                !searchResults || searchResults!.length === 0 ? (
                  <p className="w-full text-gray-500 mt-2 px-5 py-3 text-sm">No results found</p>
                ) :
                  (
                    searchResults?.map((item, index) => (
                      <div key={index} className="flex flex-col py-1">
                        <span className="text-base text-heading-gray888 font-bold px-5 py-2">{item.title.toUpperCase()}</span>
                        {item.search_preview.map((itemMatch, index) => (
                          <button
                            key={index}
                            className="flex-grow w-full flex items-start gap-3 px-5 py-3 hover:bg-gray-200 cursor-pointer border-l-4 border-white hover:border-blue-500 text-left break-words"
                            onClick={() => handleSearchResultClick(item.slug, itemMatch)}
                          >
                            <div className="min-w-0">
                              <p className="text-sm font-semibold">
                                {itemMatch.matched_section === "Article Title" ? (
                                  <span
                                    className="text-field-label-valid"
                                    dangerouslySetInnerHTML={{ __html: itemMatch.search_preview.replace(/<mark>(.*?)<\/mark>/g, '<mark class="bg-transparent text-blue-500">$1</mark>') }}
                                  />) : (
                                  <>
                                    <span className="text-field-label-valid">
                                      {itemMatch.matched_section === "Article Description" ? item.title : itemMatch.matched_section}
                                    </span>
                                    <span className="mx-2 text-field-label-valid">›</span>
                                    <span className="text-field-label-valid" dangerouslySetInnerHTML={{ __html: itemMatch.search_preview.replace(/<mark>(.*?)<\/mark>/g, '<mark class="bg-transparent text-blue-500">$1</mark>') }} />
                                  </>
                                )}
                              </p>
                            </div>
                          </button>
                        ))}
                      </div>
                    ))
                  )}
          </div>
        )}
      </div>
    </div>
  )
}
export default HelpMainSearch;